import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, Injectable } from "@angular/core";
import { ApplicationService } from "./application.service";

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    public applicationService: ApplicationService
  ) { }

  handleError(error: any) {

    if (!this.applicationService.isLocal) {
      try {
        // Check if it's an error from an HTTP response
        if (!(error instanceof HttpErrorResponse)) {
          error = error.rejection; // get the error object
        }

        let data = {
          User: this.applicationService.currentUser,
          ApplicationName: this.applicationService.currentSystem?.Name || this.applicationService.applicationName || "NA",
          Details: JSON.stringify(error, Object.getOwnPropertyNames(error))
        };

        this.applicationService.logError(data);

      }
      catch { }
    }

   
  }
}
